import React  from 'react';
import './App.css';
import './Notebook.css';
import NotebookLang from './NotebookLang.json';
import NotebookPromptToolbar from './NotebookPromptToolbar.js';

import { useNavigate } from "react-router-dom";

class NotebookPrompt extends React.Component {

	constructor(props) {

		super(props);

		this.state = {
			tab: "",
			notebookJsonObj: null,
			sourceArray: null,
			promptJsonObj: null,
			promptText: "",
			processSourcesYN: false,
			processSourceIndex: -1,
			toolbarVariableNameArray: null,
			showSaveCancelButtonsYN: false,
			jsonExtractSourceSubmit: "",
		}
		
		this.setTab = this.setTab.bind(this);		
	}
		
	async componentDidMount() {

		var notebookID = this.props.notebookID;
		var notebookJsonObj = await this.props.serverGetNotebookData(notebookID);
		var jsonExtractSourceSubmit = notebookJsonObj.jsonExtractSourceSubmit;

		var sourceArray = await this.props.serverGetSourceList(notebookID);
		var i;
		for(i=0; i<sourceArray.length; i++) {
			sourceArray[i].responseText = "";
		}

		this.setState({
			notebookJsonObj: notebookJsonObj,
			sourceArray: sourceArray,
			jsonExtractSourceSubmit: jsonExtractSourceSubmit,
		});
	}
	
	componentDidUpdate() {

		var notebookID = this.props.notebookID;
		var tab = this.state.tab;

		if (tab === "") {
			var toolbarVariableNameArray = this.getToolbarVariableNameArray();
			if (toolbarVariableNameArray.length > 0) {
				tab = toolbarVariableNameArray[0];
				this.serverGetPromptData(notebookID, tab);
				this.setState({
					tab: tab,
					toolbarVariableNameArray: toolbarVariableNameArray,
				});
			}
		}
	}
	
	async serverGetPromptData(notebookID, promptType) {

		if (notebookID <= 0) {
			return null;
		}

		var baseURLAPI = this.props.baseURLAPI;
		var url = baseURLAPI + "/getpromptdata?notebookid=" + notebookID;
		url = url + "&prompttype=" + promptType;
		
		var promptJsonObj = null;
		
		try {
			var res = await fetch(url);
			promptJsonObj = await res.json();
		} catch (err) {
		}

		if (promptJsonObj === null) {
			return;
		}

		var promptText = promptJsonObj.promptText;

		this.setState({
			promptJsonObj: promptJsonObj,
			promptText: promptText,
		});
	}

	getToolbarVariableNameArray() {

		var variableNameArray = [];
	
		// this list might depend on a client - get it from json file or db?
		variableNameArray.push("jsonExtract");
		variableNameArray.push("faq");
		variableNameArray.push("studyGuide");
		variableNameArray.push("individualSummary");
		variableNameArray.push("togetherSummary");
		variableNameArray.push("podcastScript");
		variableNameArray.push("podcastAudio");
		variableNameArray.push("system");
		
		return variableNameArray;
	}
	
	async setTab(tab) {
		var notebookID = this.props.notebookID;
		this.serverGetPromptData(notebookID, tab);
		this.setState({
			tab: tab,
		});
	}

	onKeyDown(keyCode) {
		if (keyCode === 13) {
			this.onClickSaveButton();
		}
	}

	onPromptTextChanged(value) {
		this.setState({
			promptText: value,
			showSaveCancelButtonsYN: true,
		});
	}
	
	async serverSetPromptText(promptID, promptText) {
		
		var baseURLAPI = this.props.baseURLAPI;
		var url = baseURLAPI + "/setprompttext";
		
		var jsonObj = {
			promptid: promptID,
			prompttext: promptText,
		};
		
		var jsonString = JSON.stringify(jsonObj);
		
		var res = await fetch(url, {
			method: "POST",
			headers: {
				"Content-Type": "application/json"
			},
			body: jsonString
		});

		await res.text();
	}
	
	async serverSetNotebookJsonExtractSourceSumbit(notebookID, jsonExtractSourceSubmit) {

		var baseURLAPI = this.props.baseURLAPI;
		var url = baseURLAPI + "/setnotebookjsonextractsourcesubmit?notebookid=" + notebookID;
		url = url + "&jsonextractsourcesubmit=" + jsonExtractSourceSubmit;
		
		var res = await fetch(url);
		await res.text();
	}
	
	async serverProcessOneSourceWithPrompt(notebookID, storageID, filename, promptText, userID) {
		
		var baseURLAPI = this.props.baseURLAPI;
		var url = baseURLAPI + "/processsourcewithprompt?notebookid=" + notebookID;
		url = url + "&storageid=" + encodeURIComponent(storageID);
		url = url + "&filename=" + encodeURIComponent(filename);
		url = url + "&prompttext=" + encodeURIComponent(promptText);
		url = url + "&userid=" + userID;
		
		var res = await fetch(url);
		var responseText = await res.text();
		
		return responseText;
	}
	
	async processOneSource(sourceIndex, itemObj) {

		var notebookID = this.props.notebookID;
		var notebookJsonObj = this.state.notebookJsonObj;
		var storageID = notebookJsonObj.storageID;
		var promptText = this.state.promptText;
		var userID = this.props.userID;

		var filename = itemObj.filename;
		
		this.setState({
			processSourceIndex: sourceIndex,
		});

		var responseText = await this.serverProcessOneSourceWithPrompt(notebookID, storageID, filename, promptText, userID);
		var sourceArray = this.state.sourceArray;
		sourceArray[sourceIndex].responseText = responseText;
	}

	async processAllSources() {

		var promptText = this.state.promptText;
		var sourceArray = this.state.sourceArray;
		if (sourceArray === null) {
			return;
		}

		this.setState({
			processSourcesYN: true,
		});
			
		var i;
		var itemObj;
		
		for(i=0; i<sourceArray.length; i++) {
			itemObj = sourceArray[i];
			await this.processOneSource(i, itemObj);
		}
	}

	onClickBackToNotebook() {
		var navigate = this.props.navigate;
  		navigate("/notebook");
	}

	async onClickSaveButton() {
		
		var promptJsonObj = this.state.promptJsonObj;
		if (promptJsonObj === null) {
			this.props.showToast("Error - cannot save prompt");
			return;
		}
		
		var promptID = promptJsonObj.promptID;
		var tab = this.state.tab;
		var notebookJsonObj = this.state.notebookJsonObj;
		var promptText = this.state.promptText;
		var notebookID = notebookJsonObj.notebookID;

		promptText = promptText.trim();

		await this.serverSetPromptText(promptID, promptText);
		
		//await this.processAllSources();

		var toastString = this.props.getLang(NotebookLang, "promptSaved");
		this.props.showToast(toastString);

		this.setState({showSaveCancelButtonsYN: false});
	}
	
	onClickCancelButton() {

		var notebookID = this.props.notebookID;
		var tab = this.state.tab;
		this.serverGetPromptData(notebookID, tab);

		var toastString = this.props.getLang(NotebookLang, "promptCancelled");
		this.props.showToast(toastString);

		this.setState({showSaveCancelButtonsYN: false});
	}
	
	setNotebookJsonExtractSourceSumbit(jsonExtractSourceSubmit) {
		this.setState({jsonExtractSourceSubmit: jsonExtractSourceSubmit});
		var notebookID = this.props.notebookID;
		this.serverSetNotebookJsonExtractSourceSumbit(notebookID, jsonExtractSourceSubmit);
	}
	
	renderProcessOneSource(index, itemObj) {

		var key = "source-" + index;
		var filename = itemObj.filename;
		var responseText = itemObj.responseText;

		return (
			<div key={key}>
				<div>{filename}</div>
				<div style={{height: "10px"}}></div>
				<div>{responseText}</div>
				<div style={{height: "10px"}}></div>
				<hr/>
				<div style={{height: "20px"}}></div>
			</div>
		);
	}

	renderProcessSources() {
		
		var processSourceIndex = this.state.processSourceIndex;
		if (processSourceIndex < 0) {
			return;
		}
		var sourceArray = this.state.sourceArray;
		
		var i;
		var itemObj;
		var jsxCode;
		var jsxArray = [];
		
		for(i=0; i<sourceArray.length; i++) {
			itemObj = sourceArray[i];
			jsxCode = this.renderProcessOneSource(i, itemObj);	
			jsxArray.push(jsxCode);
		}
		
		itemObj = sourceArray[processSourceIndex];
		var filename = itemObj.filename;
		var filenameUpper = filename.toUpperCase();

		return (
			<div>
				<div style={{height: "20px"}}></div>
				<div><b>{filenameUpper}</b></div>
				<div style={{height: "20px"}}></div>
				<hr/>
				<div style={{height: "20px"}}></div>
				{jsxArray}
				<div style={{height: "20px"}}></div>
			</div>
		);
	}
	
	renderButtons() {

		var showSaveCancelButtonsYN = this.state.showSaveCancelButtonsYN;
		
		if (showSaveCancelButtonsYN) {
			return (
				<div className="ViewContainerButtons2">
					<button className="ViewCancelButton" onClick={() => this.onClickCancelButton()}>{this.props.getLang(NotebookLang, "cancel")}</button>
					<div style={{width: "20px"}}></div>
					<button className="ViewSaveButton" onClick={() => this.onClickSaveButton()}>{this.props.getLang(NotebookLang, "save")}</button>
				</div>
			);
		}

		return (
			<button className="NotebookGreyButton" onClick={() => this.onClickBackToNotebook()}>{this.props.getLang(NotebookLang, "backToNotebook")}</button>
		);
	}
	
	renderJsonExtractSourceSubmit() {

		var tab = this.state.tab;
		var jsonExtractSourceSubmit = this.state.jsonExtractSourceSubmit;
		
		if (tab !== "jsonExtract") {
			return;
		}
		
		var submitOriginalDocumentsYN = false;
		var submitMarkdownYN = false;
		
		if (jsonExtractSourceSubmit === "original") {
			submitOriginalDocumentsYN = true;
		}
		
		if (jsonExtractSourceSubmit === "markdown") {
			submitMarkdownYN = true;
		}
		
		return (
			<div>
				<div style={{height: "20px"}}></div>
				<center>
				<div style={{ display: 'flex', alignItems: 'center', width: 'fit-content' }}>
					<input type="checkbox" style={{ marginTop: '8px' }} id="submitOriginalDocuments" checked={submitOriginalDocumentsYN} onChange={(event) => this.setNotebookJsonExtractSourceSumbit("original")}/>
					<label htmlFor="submitOriginalDocuments" style={{ fontSize: '16px' }}>
						{this.props.getLang(NotebookLang, "submitOriginalDocuments")}
					</label>&nbsp;&nbsp;&nbsp;&nbsp;
					<input type="checkbox" style={{ marginTop: '8px' }} id="submitMarkdown" checked={submitMarkdownYN} onChange={(event) => this.setNotebookJsonExtractSourceSumbit("markdown")}/>
					<label htmlFor="submitMarkdown" style={{ fontSize: '16px' }}>
						{this.props.getLang(NotebookLang, "submitMarkdown")}
					</label>
				</div>
				</center>
			</div>
		);
	}
		
	render() {
		
		var notebookJsonObj = this.state.notebookJsonObj;
		if (notebookJsonObj === null) {
			return;
		}
		
		var processSourcesYN = this.state.processSourcesYN;
		if (processSourcesYN) {
			return this.renderProcessSources();
		}
		
		var notebookID = this.props.notebookID;
		var notebookTitle = notebookJsonObj.title;
		var promptText = this.state.promptText;
		
		var notebookTitle2 = notebookTitle + " (id: " + notebookID + ")";
		var toolbarVariableNameArray = this.state.toolbarVariableNameArray;

		var tabString = this.props.getLang(NotebookLang, this.state.tab);

		return (
			<div>
				<NotebookPromptToolbar
					notebookID={this.props.notebookID}
					tab={this.state.tab}
					toolbarVariableNameArray={toolbarVariableNameArray}					
					setTab={this.setTab}
					getLang={this.props.getLang}
				/>
				<div style={{height: "30px"}}></div>
				<div className="ViewTopTitle">{this.props.getLang(NotebookLang, "editPrompt")} - {tabString}</div>
				<div className="ViewTopText">{this.props.getLang(NotebookLang, "editPromptInstr")}</div>

				<div style={{height: "30px"}}></div>
				<div className="ViewBlockContainer">
					<div style={{height: "15px"}}></div>
					<div className="ViewBlockTitle">{this.props.getLang(NotebookLang, "promptInfo")}</div>
					<div style={{height: "20px"}}></div>
					<div className="ViewContainer2">
						<fieldset className="PromptEditFieldset">
							<legend className="PromptEditLegend">{this.props.getLang(NotebookLang, "notebook")}</legend> 
							<input
								className="PromptEditInput" 
								id="notebook" 
								type="text" 
								disabled={true}
								value={notebookTitle2}
								onChange={(event) => this.onModelNameChanged(event.target.value)}
								onKeyDown={(event) => this.onKeyDown(event.keyCode)}
							/>
						</fieldset>
					</div>

					<div style={{height: "20px"}}></div>
					<div className="ViewContainer2">
						<fieldset className="PromptEditFieldset">
							<legend className="PromptEditLegend">{this.props.getLang(NotebookLang, "promptText")}</legend> 
							<textarea
								className="PromptEditInput" 
								autoFocus={true}
								id="helloMessage" 
								type="text" 
								rows={15}
								value={promptText}
								onChange={(event) => this.onPromptTextChanged(event.target.value)}
							/>
						</fieldset>
					</div>
					{this.renderJsonExtractSourceSubmit()}
					<div style={{height: "60px"}}></div>
					{this.renderButtons()}
					<div style={{height: "50px"}}></div>
				</div>

				<div style={{height: "100px"}}></div>
			</div>
		);
	}
}

export default function NotebookPromptFunction(props) {
	const navigate = useNavigate();
	return <NotebookPrompt {...props} navigate={navigate} />;
}


